import { createContext } from "react";
import LocalStorageService from "services/LocalStorageService";
import StatComputationService from "services/StatComputationService";

export const ServiceLocatorContext = createContext({
    localStorageService: new LocalStorageService(),
    statComputationService: new StatComputationService()
});
